import loadable from '@loadable/component'

export default [
  {
    path: '/starGift/template',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-StarGift-pages-template" */ '~/pages/StarGift/pages/template'
        )
    ),
  },
  {
    path: '/starGift/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-StarGift-pages-rule" */ '~/pages/StarGift/pages/rule'
        )
    ),
  },
  {
    path: '/starGift/card',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-StarGift-pages-card" */ '~/pages/StarGift/pages/card'
        )
    ),
  },
  {
    path: '/starGift/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-StarGift-pages-banner" */ '~/pages/StarGift/pages/banner'
        )
    ),
  },
]
